import { combineReducers } from "redux";
import appReducer from "./app/reducer";
import authenticationReducer from "./authentication/reducer";
import eventsReducer from "./events/reducer";
import footballPlayReducer from "./football-play/reducer";
import gameReducer from "./game/reducer";
import gameContextReducer from "./game-context/reducer";
import homeReducer from "./home/reducer";
import layoutReducer from "./layout/reducer";
import menuReducer from "./menu/reducer";
import teamReducer from "./teams/reducer";
import teamContextReducer from "./team-context/reducer";
import seasonReducer from "./season/reducer";
import playersReducer from "./players/reducer";
import sportReducer from "./sport/reducer";
import statsReducer from "./stats/reducer";
import matchesReducer from "./matches/reducer";
import streamReducer from "./stream/reducer";

export default combineReducers({
	app: appReducer,
	authentication: authenticationReducer,
	events: eventsReducer,
	footballPlay: footballPlayReducer,
	game: gameReducer,
	gameContext: gameContextReducer,
	home: homeReducer,
	layout: layoutReducer,
	menu: menuReducer,
	teamContext: teamContextReducer,
	teams: teamReducer,
	season: seasonReducer,
	players: playersReducer,
	sport: sportReducer,
	stats: statsReducer,
	matches: matchesReducer,
	stream: streamReducer
});
